export var BybitOrderStatusEnum;
(function (BybitOrderStatusEnum) {
    BybitOrderStatusEnum["REJECTED"] = "Rejected";
    BybitOrderStatusEnum["PARTIALLY_FILLED_CANCELED"] = "PartiallyFilledCanceled";
    BybitOrderStatusEnum["FILLED"] = "Filled";
    BybitOrderStatusEnum["CANCELLED"] = "Cancelled";
    BybitOrderStatusEnum["TRIGGERED"] = "Triggered";
    BybitOrderStatusEnum["DEACTIVATED"] = "Deactivated";
    BybitOrderStatusEnum["NEW"] = "New";
    BybitOrderStatusEnum["PARTIALLY_FILLED"] = "PartiallyFilled";
    BybitOrderStatusEnum["UNTRIGGERED"] = "Untriggered";
    BybitOrderStatusEnum["CREATED"] = "Created";
})(BybitOrderStatusEnum || (BybitOrderStatusEnum = {}));
//# sourceMappingURL=bybit-order-status.enum.js.map